import { Link } from "react-router-dom";
import styled from "styled-components";

export const RoomsList = styled.article`
    display: grid;
    grid-template-columns: auto;
    grid-gap: 10px;
    grid-row-gap: 10px;

    @media (min-width: 767px) {
        grid-template-columns: auto auto;
    }

    @media (min-width: 959px) {
        grid-template-columns: auto auto auto;
    }
`;

export const CustomButtonGroup = styled.div`
    display:flex;
    margin-top: 10px;

    a {
        button {
            border-radius: 0;
        }

        &:first-child{
            button {
                border-radius: 25px 0 0 25px;
            }
        }

        &:last-child {
            button {
                border-radius: 0 25px 25px 0;
            }
        }

        &:only-child {
            button {
                border-radius: 25px;
            }
        }
    }
`;

export const CustomLink = styled(Link)`
    display: flex;
    text-decoration: none;
`;

export const ButtonLink = styled.button`
    background-color: transparent;
    color: ${props => props.theme.colors.primaryText};
    border: none;
    padding: 0;
    margin: 0;
    text-decoration: underline;
    cursor: pointer;
`;